import React from 'react';

import { Box, Typography } from '@mui/material';

import * as ListStyles from '@common/modules/Chat/Title/Rules/Steps/styled';
import ContentCard from '@common/modules/Chat/Title/Rules/TeacherModalContent/ContentCard';
import {
	requestExamplesConfig,
	requestRulesConfig,
} from '@common/modules/Chat/Title/Rules/TeacherModalContent/rulesData';

import * as Styled from './styled';

function ThirdStep() {
	return (
		<>
			<Styled.Subtitle variant="subtitle1" marginBottom={1}>
				Приклади запитів і розподіл зон відповідальності:
			</Styled.Subtitle>
			<Styled.Grid>
				{requestExamplesConfig.map((column, colIndex) => (
					<>
						{column.title && (
							<ContentCard
								logo={column.title}
								wrapperStyle={{ gridColumn: `${colIndex + 1}/${colIndex + 2}`, gridRow: '1/2' }}
							/>
						)}
						{column.subtitle && (
							<ContentCard
								text={column.subtitle}
								textStyle={{ fontWeight: 600 }}
								wrapperStyle={{ gridColumn: `${colIndex + 1}/${colIndex + 2}`, gridRow: '2/3' }}
							/>
						)}
						{column.items.map((item, itemIndex) => (
							<ContentCard
								key={itemIndex}
								text={item}
								wrapperStyle={{
									gridColumn: `${colIndex + 1}/${colIndex + 2}`,
									gridRow: `${itemIndex + 3}/${itemIndex + 4}`,
								}}
							/>
						))}
					</>
				))}
			</Styled.Grid>
			{requestRulesConfig.map((item, index) => (
				<Box display="flex" gap={1} alignItems="center" key={index}>
					<ListStyles.Step isActive sx={{ transform: 'scale(0.6)', alignSelf: 'baseline' }}>
						{item.icon}
					</ListStyles.Step>
					<Box>
						<Typography variant="body2" fontFamily="MuseoSansCyrl" fontWeight={600}>
							{item.text}
						</Typography>
						<Typography variant="body2" fontFamily="MuseoSansCyrl" marginTop={1}>
							{item.subText}
						</Typography>
					</Box>
				</Box>
			))}
		</>
	);
}

export default ThirdStep;
